import { render, staticRenderFns } from "./allotList.vue?vue&type=template&id=9a09634a&scoped=true"
import script from "./allotList.vue?vue&type=script&lang=js"
export * from "./allotList.vue?vue&type=script&lang=js"
import style0 from "./allotList.vue?vue&type=style&index=0&id=9a09634a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a09634a",
  null
  
)

export default component.exports